export const FORM_ID = 'ff-import-ids-form';
export const UNKNOWN_ERROR_MESSAGE = 'Could not submit form due to an error';
export const SUCCESS_MESSAGE = 'Import succeeded';

// For the "Entity type" question on the setup step of the import modal
export const ID_TYPE_INPUT_LABEL = '1. For this entity type...';
export const ALL_PROJECTS_OPTION = 'All Projects';
export const ALL_ORGS_OPTION = 'All Organizations';
export const VALIDATION_MSG_ID_TYPE_REQUIRED = 'Please select an ID type';

// For the "Import type" question on the setup step of the import module
export const IMPORT_TYPE_INPUT_LABEL = '2. Do the following...';
export const ENABLE_FEATURE_OPTION = 'Enable Feature';
export const DISABLE_FEATURE_OPTION = 'Disable Feature';
export const VALIDATION_MSG_IMPORT_TYPE_REQUIRED = 'Please select an import type';

export const CHANGE_COMMENT_INPUT_LABEL = '3. For the following reason...';
export const CHANGE_COMMENT_INPUT_PLACEHOLDER =
  'Leave an audit trail by providing an optional comment for the change log';
export const CHANGE_COMMENT_INPUT_HELP_TEXT =
  'Optional — One will be generated for you if no comment is provided';

export const SUBMIT_SETUP_STEP = 'Review changes';
export const SUBMIT_REVIEW_STEP = 'Start import';
export const GO_BACK = 'Back';

export const ENABLED = 'enabled';
export const DISABLED = 'disabled';
export const PROJECT = 'project';
export const ORGANIZATION = 'organization';
